import Header from "component/Header/Header";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Grid from "@mui/material/Grid";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const NoSaldoComponent = () => {
  let history = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Header />

      <div
        style={{
          marginTop: "15%",
          backgroundColor: "#F9CDD0",
          border: "red 1px ridge",
          width: "60%",
          alignSelf: "center",
        }}
      >
        <Grid container sx={{ width: "100%" }}>
          <Grid size={{ xs: 1 }}>
            <ErrorRoundedIcon
              fontSize="large"
              color="secondary"
              style={{ marginTop: "25%", marginLeft: "25%" }}
            />
          </Grid>
          <Grid size="grow">
            <p>
              No hay saldo suficiente para generar este vale. Solicitá por
              e-mail a tu Oficina Comercial la recarga de saldo.
            </p>
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          marginTop: "5%",

          alignSelf: "center",
        }}
      >
        <Button
          onClick={() => {
            localStorage.removeItem("idvale");
            history(-1);
          }}
          startIcon={<ArrowBackIosIcon />}
          style={{
            textTransform: "none",
            alignSelf: "center",
            color: "#0055A6",
          }}
        >
          Volver
        </Button>
      </div>
    </div>
  );
};
export default NoSaldoComponent;
